// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimActivityBriefDto
 */
export interface IClaimActivityBriefDto {
    /**
     * 
     * @type {Date}
     * @memberof IClaimActivityBriefDto
     */
    date_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimActivityBriefDto
     */
    date_to?: Date;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityBriefDto
     */
    paid_claims_count?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityBriefDto
     */
    submitted_claims_count?: number;
}

/**
 * Check if a given object implements the IClaimActivityBriefDto interface.
 */
export function instanceOfIClaimActivityBriefDto(value: object): value is IClaimActivityBriefDto {
    return true;
}

export function IClaimActivityBriefDtoFromJSON(json: any): IClaimActivityBriefDto {
    return IClaimActivityBriefDtoFromJSONTyped(json, false);
}

export function IClaimActivityBriefDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimActivityBriefDto {
    if (json == null) {
        return json;
    }
    return {
        
        'date_from': json['date_from'] == null ? undefined : (new Date(json['date_from'])),
        'date_to': json['date_to'] == null ? undefined : (new Date(json['date_to'])),
        'paid_claims_count': json['paid_claims_count'] == null ? undefined : json['paid_claims_count'],
        'submitted_claims_count': json['submitted_claims_count'] == null ? undefined : json['submitted_claims_count'],
    };
}

export function IClaimActivityBriefDtoToJSON(json: any): IClaimActivityBriefDto {
    return IClaimActivityBriefDtoToJSONTyped(json, false);
}

export function IClaimActivityBriefDtoToJSONTyped(value?: IClaimActivityBriefDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date_from': value['date_from'] == null ? undefined : ((value['date_from']).toISOString().substring(0,10)),
        'date_to': value['date_to'] == null ? undefined : ((value['date_to']).toISOString().substring(0,10)),
        'paid_claims_count': value['paid_claims_count'],
        'submitted_claims_count': value['submitted_claims_count'],
    };
}

